import { ReactNode } from "react";

const basePath = import.meta.env.BASE_URL.replace(/\/$/, "");

export function AuthLayout({ children }: { children: ReactNode }) {
  return (
    <div className="flex min-h-[100dvh] flex-col md:flex-row">
      {/* Brand panel — compact header on mobile, full left column on desktop */}
      <div
        className="
          flex items-center justify-center gap-3
          bg-[hsl(187,64%,43%)] text-white
          px-6 py-5
          md:w-[45%] md:flex-col md:gap-6 md:px-12 md:py-16
          shrink-0
        "
      >
        {/* Logo — rendered white against the brand-color background */}
        <img
          src={`${basePath}/logo.svg`}
          alt="TDM"
          className="h-10 w-auto md:h-20"
          style={{ filter: "brightness(0) invert(1)" }}
        />

        {/* Brand text — always visible */}
        <div className="flex flex-col md:items-center md:text-center">
          <span className="text-sm font-medium opacity-[0.85] md:text-base md:mt-1">
            Total Deal Management
          </span>
        </div>

        {/* Tagline — desktop only */}
        <p className="hidden md:block text-sm opacity-70 text-center max-w-xs leading-relaxed mt-2">
          Streamline your channel partner deal registrations from submission to
          approval.
        </p>
      </div>

      {/* Form panel */}
      <div className="flex flex-1 items-center justify-center bg-background px-4 py-10 overflow-auto">
        <div className="w-full max-w-[420px]">
          {children}
        </div>
      </div>
    </div>
  );
}
